import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VContainer,[_c(VRow,{attrs:{"justify":"center"}},[_vm._l((_vm.listThisItems),function(item,index){return [_c(VCol,{key:index,attrs:{"cols":"12","sm":"auto"}},[_c('service-card',{attrs:{"image":item.image,"title":item.title ? item.title : item.warrantyTypeName,"path":_vm.useAltPath ? item.altPath : item.path,"available-service-id":item.id,"is-external-link":item.isExternal}})],1)]})],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }